import * as React from "react"
import { useTranslation } from "react-i18next"

import Details from "Catalog/Edit/shared/components/Details"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import StatefulField from "shared/components/StatefulField"
import useEditor from "shared/hooks/useEditor"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { ICategory, ICategoryOrProduct, IProduct } from "shared/hubrise/models"
import { TagOption } from "shared/hubrise/utils/tags"

import Commands from "./Commands"
import Dimensions from "./Dimensions"
import General from "./General"
import Nutrition from "./Nutrition"
import OptionLists from "./OptionLists"
import Skus from "./Skus"
import { SectionDivider } from "./Styles"

const ProductContent = ({ product, tagOptions }: { product: IProduct; tagOptions: Array<TagOption> }): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigateNoUpdate()
  const { editor } = useEditor()
  const { catalogNavigation } = useCatalogNavigation()

  const handleChange =
    <TField extends keyof ICategoryOrProduct>(field: TField, options?: { collapse?: boolean }) =>
    (value: (ICategory & IProduct)[TField]) =>
      editor.categoryOrProduct.update(product, field, value, options)

  return (
    <>
      <Details.Topbar
        commands={<Commands categoryOrProduct={product} />}
        onClose={() => navigate(catalogNavigation.editPath("products"))}
      >
        <StatefulField.Title
          name="product-name"
          initialValue={product.name}
          placeholder={t("product.name.placeholder.product")}
          onChange={handleChange("name")}
          validate={(name) => (name.length === 0 ? t("validations.not_empty") : undefined)}
        />
      </Details.Topbar>

      <General product={product} tagOptions={tagOptions} />

      <SectionDivider />
      <Skus product={product} />

      <SectionDivider />
      <Dimensions product={product} />

      <SectionDivider />
      <OptionLists product={product} />

      <SectionDivider />
      <Nutrition product={product} />
    </>
  )
}

export default ProductContent
